import { getHubSpotClient } from "./client";
import { HubSpotOwner } from "./types";

type OwnersPage = ReturnType<typeof getHubSpotClient>["crm"]["owners"]["ownersApi"]["getPage"];

export async function getOwners(getPage: OwnersPage = getHubSpotClient().crm.owners.ownersApi.getPage): Promise<HubSpotOwner[]> {
  const owners = new Map<string, HubSpotOwner>();
  const cursors = new Set<string>();
  let after: string | undefined;
  do {
    const page = await getPage(undefined, after, 100, false);
    for (const owner of page.results) {
      if (!owner.archived) owners.set(owner.id, owner);
    }
    after = page.paging?.next?.after;
    if (after !== undefined) {
      if (cursors.has(after)) throw new Error("La paginación de comerciales de HubSpot no es válida.");
      cursors.add(after);
    }
  } while (after !== undefined);
  return [...owners.values()];
}
